export const HELP_TOOLTIP_TYPES = {
  AUDIENCE: 'AUDIENCE',
  SCREENING: 'SCREENING',
  AB_TEST_MONADIC: 'AB_TEST_MONADIC',
  AB_TEST_SEQUENTIAL: 'AB_TEST_SEQUENTIAL',
  SCHEDULING: 'SCHEDULING',
  CROSS_TABS: 'CROSS_TABS',
  TRANSLATIONS: 'TRANSLATIONS',
  QUESTION_TYPE: 'QUESTION_TYPE',
  SURVEY_QUESTIONS: 'SURVEY_QUESTIONS',
};

export const HELP_TOOLTIP_TYPES_URL_MAP = {
  [HELP_TOOLTIP_TYPES.AUDIENCE]:
    'https://resources.pollfish.com/pollfish-school/incorporating-multiple-audiences-into-your-survey/',
  [HELP_TOOLTIP_TYPES.SCREENING]:
    'https://resources.pollfish.com/pollfish-school/how-to-use-pollfish-screening-questions-like-a-pro/',
  [HELP_TOOLTIP_TYPES.AB_TEST_MONADIC]:
    'https://resources.pollfish.com/pollfish-school/new-pollfish-feature-a-b-testing-directly-in-questions-with-the-monadic-version/',
  [HELP_TOOLTIP_TYPES.AB_TEST_SEQUENTIAL]:
    'https://resources.pollfish.com/pollfish-school/new-pollfish-feature-sequential-testing-a-variation-of-monadic-testing/',
  [HELP_TOOLTIP_TYPES.SCHEDULING]:
    'https://resources.pollfish.com/pollfish-school/how-to-schedule-recurring-surveys-in-pollfish/',
  [HELP_TOOLTIP_TYPES.CROSS_TABS]:
    'https://resources.pollfish.com/pollfish-school/guide-to-using-crosstabs-in-pollfish/',
  [HELP_TOOLTIP_TYPES.TRANSLATIONS]:
    'https://resources.pollfish.com/pollfish-school/incorporating-the-translate-survey-feature-into-your-surveys/',
  [HELP_TOOLTIP_TYPES.QUESTION_TYPE]:
    'https://resources.pollfish.com/market-research/how-to-write-good-survey-questions/',
  [HELP_TOOLTIP_TYPES.SURVEY_QUESTIONS]:
    'https://resources.pollfish.com/market-research/how-to-write-good-survey-questions/',
};
